import { createCtx } from '@mi-front/core';

export interface PageDrawerContextValue {
  open: boolean;
  /** Opens the drawer (expand panel). Content is rendered by the drawer slot. Pages may pass contentType/onClose (e.g. stream). */
  openDrawer: (contentType?: string, onClose?: () => void) => void;
  /** Closes the drawer (collapse panel). */
  closeDrawer: () => void;
}

const [usePageDrawer, PageDrawerContextProvider] = createCtx<PageDrawerContextValue>({
  throwIfMissingProvider: true,
});

export { PageDrawerContextProvider, usePageDrawer };
